import MetropoleHeader from './components/MetropoleHeader/MetropoleHeader'
import BasicHeader from './components/BasicHeader/BasicHeader'
import MetropoleOnlyHeader from './components/MetropoleOnlyHeader/MetropoleOnlyHeader'
import VilleOnlyHeader from './components/VilleOnlyHeader/VilleOnlyHeader'
import MetropoleCCASHeader from './components/MetropoleCCASHeader/MetropoleCCASHeader'
import VilleCCASHeader from './components/VilleCCASHeader/VilleCCASHeader'
import EnfantsAmbassadeursHeader from './components/EnfantsAmbassadeursHeader/EnfantsAmbassadeursHeader'
import FranceService from './components/FranceService/FranceService'
import MontpellierIAConnect from './components/MontpellierIAConnect/MontpellierIAConnect'
import PoleEducation from './components/PoleEducation/PoleEducation'
import ServiceElections from './components/ServiceElections/ServiceElections'
import IngenierieAgroecologique from './components/IngenierieAgroecologique/IngenierieAgroecologique'
import PoleEducation2 from './components/PoleEducation2/PoleEducation2'
import MPTLeLabo from './components/MPTLeLabo/MPTLeLabo'
import PoleRessourcesHumaines from './components/PoleRessourcesHumaines/PoleRessourcesHumaines'
import CommunauteDataIAHeader from './components/CommunauteDataIAHeader/CommunauteDataIAHeader'
import ComedieDuLivreHeader from './components/ComedieDuLivreHeader/ComedieDuLivreHeader'
import MuseeFabreHeader from './components/MuseeFabreHeader/MuseeFabreHeader'
import MetropoleMuseeFabreHeader from './components/MetropoleMuseeFabreHeader/MetropoleMuseeFabreHeader'
import NoelSolidaireHeader from './components/NoelSolidaireHeader/NoelSolidaireHeader'

const headersForms = [
  {
    value: 'Métropole',
    label: 'En-tête Bienvenue Métropole',
    component: <MetropoleHeader />,
  },
  {
    value: 'CCAS',
    label: 'En-tête CCAS',
    component: <VilleCCASHeader />,
  },
  {
    value: 'ComedieDuLivre',
    label: 'En-tête Comédie du Livre',
    component: <ComedieDuLivreHeader />,
  },
  {
    value: 'CommunauteDataIA',
    label: 'En-tête Communauté DATA & IA',
    component: <CommunauteDataIAHeader />,
  },
  {
    value: 'EnfantsAmbassadeurs',
    label: 'En-tête Enfants Ambassadeurs',
    component: <EnfantsAmbassadeursHeader />,
  },
  {
    value: 'FranceService',
    label: 'En-tête France Service',
    component: <FranceService />,
  },
  {
    value: 'IngenierieAgroecologique',
    label: 'En-tête Ingienérie Agroécologique',
    component: <IngenierieAgroecologique />,
  },
  {
    value: 'MetropoleOnly',
    label: 'En-tête Métropole',
    component: <MetropoleOnlyHeader />,
  },
  {
    value: 'MetropoleMuseeFabre',
    label: 'En-tête Métropole/Musée Fabre',
    component: <MetropoleMuseeFabreHeader />,
  },
  {
    value: 'basic',
    label: 'En-tête Métropole/Ville',
    component: <BasicHeader />,
  },
  {
    value: 'MetropoleCCAS',
    label: 'En-tête Métropole/Ville/CCAS',
    component: <MetropoleCCASHeader />,
  },
  {
    value: 'MontpellierIAConnect',
    label: 'En-tête Montpellier IA',
    component: <MontpellierIAConnect />,
  },
  {
    value: 'MPTLeLabo',
    label: 'En-tête MPT Le Labo',
    component: <MPTLeLabo />,
  },
  {
    value: 'MuseeFabre',
    label: 'En-tête Musée Fabre',
    component: <MuseeFabreHeader />,
  },
  {
    value: 'NoelSolidaire',
    label: 'En-tête Noël Solidaire',
    component: <NoelSolidaireHeader />,
  },
  {
    value: 'PoleEducation',
    label: 'En-tête Pôle Education',
    component: <PoleEducation />,
  },
  {
    value: 'PoleEducation2',
    label: 'En-tête Pôle Education 2',
    component: <PoleEducation2 />,
  },
  {
    value: 'PoleRessourcesHumaines',
    label: 'En-tête Pôle Ressources Humaines',
    component: <PoleRessourcesHumaines />,
  },
  {
    value: 'ServiceElections',
    label: 'En-tête PRUHEC',
    component: <ServiceElections />,
  },
  {
    value: 'VilleOnly',
    label: 'En-tête Ville',
    component: <VilleOnlyHeader />,
  },
]

export default headersForms
